module.exports = __webpack_public_path__ + "img/bsignup-continue-1.44f7e110.png";